/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { SHOW_LOADER, HIDE_LOADER } from "./types";

export const showLoaderAction = (component?: string) => {
  return {
    type: SHOW_LOADER,
    displayLoader: true,
    component: component || "",
  };
};

export const hideLoaderAction = (component?: string) => {
  return {
    type: HIDE_LOADER,
    displayLoader: false,
    component: component || "",
  };
};
